import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { Type } from 'react-spark';

class ApprovalBanner extends Component {
    render() {
        return (
            <div className="approval-banner sprk-o-Box sprk-u-mbm text-center">
                <Type.DisplayTwo>
          Congrats! You&#39;re prequalified for up to{' '}
                    <FormattedNumber
                        value={Math.floor(this.props.maxOffer)}
                        currency="USD"
                        maximumFractionDigits={0}
                        style="currency"
                    />
                    <sup className="superscript">*</sup>
                </Type.DisplayTwo>
            </div>
        );
    }
}


ApprovalBanner.propTypes = {
    maxOffer: PropTypes.number.isRequired,
};

export default ApprovalBanner;
